export default __webpack_public_path__ + "static/media/icon-ic-done.84c968ac.svg";